function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
import { nodeArray } from 'meteora';
var HoverTargets = /*#__PURE__*/_createClass(function HoverTargets(container, func) {
  var _this = this;
  _classCallCheck(this, HoverTargets);
  this.container = container;
  this.triggers = nodeArray(this.container.querySelectorAll('[data-hover]'));
  this.targets = nodeArray(this.container.querySelectorAll('[data-hover-target]'));
  this.relationships = {};
  this.triggers.forEach(function (trigger) {
    var key = trigger.getAttribute('data-hover');
    _this.relationships[key] = {};
    _this.relationships[key].trigger = trigger;
    _this.relationships[key].targets = [];
  });
  this.targets.forEach(function (target) {
    for (var key in _this.relationships) {
      if (key === target.getAttribute('data-hover-target')) {
        _this.relationships[key].targets.push(target);
      }
    }
  });
  var _loop = function _loop(key) {
    _this.relationships[key].trigger.addEventListener('mouseenter', function () {
      _this.relationships[key].targets.forEach(function (target) {
        func(target, _this.relationships, key);
      });
    });
  };
  for (var key in this.relationships) {
    _loop(key);
  }
});
export { HoverTargets as default };